import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['content', 'form'];

  static values = {
    programId: Number,
    userIds: String
  }

  connect() {
    this._boundOpenEditor = this._openEditor.bind(this);
    this._boundCloseEditor = this._closeEditor.bind(this);

    document.addEventListener('promote:open-members-editor', this._boundOpenEditor);
    document.addEventListener('promote:close-members-editor', this._boundCloseEditor);

    let userIds;

    try {
      const parsed = JSON.parse(this.userIdsValue);
      userIds = Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      userIds = null;
    }

    if (userIds === undefined || userIds === null) { return; }

    if (userIds.filter(id => id !== null).length === 1) {
      this._updateUrlOnOpen(userIds[0]);
      this._loadEditEditor(userIds[0]);
    }
  }

  disconnect() {
    document.removeEventListener('promote:open-members-editor', this._boundOpenEditor);
    document.removeEventListener('promote:close-members-editor', this._boundCloseEditor);
  }

  async verifyFormsAndClose() {
    try {
      await this.verify();
      this._boundCloseEditor();
    } catch (e) {
      // no-op
    }
  }

  async verify() {
    const unloadChecker = this.application
      .getControllerForElementAndIdentifier(document.body, "unload-checker");

    return await unloadChecker.verify();
  }

  submit(event) {
    event.preventDefault();
    this._submitForm();
  }

  submitAndExit(event) {
    event.preventDefault();
    this._submitForm(true);
  }

  get panelEditorController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'panel-editor');
  }

  _loadEditEditor(id) {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    Rails.ajax({
      url: `/admin/programs/${this.programIdValue}/members/${id}/edit`,
      type: "GET",
      dataType: "script",
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    });
  }

  _submitForm(exit = false) {
    this.formTarget.dispatchEvent(new CustomEvent("ajax:beforeSend", { bubbles: true }));

    if (this.formTarget.checkValidity()) {
      const formData = new FormData(this.formTarget);
      formData.append('button', exit ? 'exit' : 'save');

      Rails.ajax({
        url: this.formTarget.action,
        type: this.formTarget.method,
        data: formData,
        dataType: "script",
        beforeSend: (xhr) => {
          this.ajaxRequest = xhr;
          return true;
        },
        success: () => {
          if (exit) { this._closeEditor(); }
        },
      });
    }
  }

  _openEditor() {
    this.panelEditorController.openPanel(this.verifyFormsAndClose.bind(this));
  }

  _closeEditor() {
    this.panelEditorController.closePanel();
    this._updateUrlOnClose();
  }

  _updateUrlOnOpen(id) {
    window.history.pushState({}, "", `/admin/programs/${this.programIdValue}/members/${id}/edit`);
  }

  _updateUrlOnClose() {
    window.history.pushState({}, "", `/admin/programs/${this.programIdValue}/members`);
  }
}
